import styled from 'styled-components';

const Image = styled.div`
  height: ${(props) => props.height || '252px'};
  width: 100%;
  background-image: url(${(props) => props.link || ''});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-top: 20px;
  margin-bottom: 10px;
`;

export default Image;
